import { toast } from 'react-toastify'
import { getCookie, setCookie } from '../../../../modules/cookie'

const clearLinkedInCookie = (name: string) => {
  // Expire with same domain/path attributes the backend used
  setCookie(name, '', -1)
}

/**
 * Handle LinkedIn OAuth error cookie set by papaya `/auth/linkedin`.
 */
export const handleLinkedInErrors = (): boolean => {
  const cookieError = getCookie('linkedin_error')
  if (cookieError !== 'true') {
    return false
  }

  clearLinkedInCookie('linkedin_error')

  toast.error('LinkedIn connection failed. Please try again or check your LinkedIn Ads account.', {
    position: 'top-right',
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  })

  return true
}

/**
 * Handle LinkedIn OAuth success cookie set by papaya `/auth/linkedin`.
 */
export const handleLinkedInSuccess = (): boolean => {
  const cookieSuccess = getCookie('linkedin_connected')
  if (cookieSuccess !== 'true') {
    return false
  }

  clearLinkedInCookie('linkedin_connected')

  toast.success('LinkedIn connected successfully!', {
    position: 'top-right',
    autoClose: 4000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  })

  return true
}
